import { render, staticRenderFns } from "./EditInput.vue?vue&type=template&id=67589a6a&scoped=true"
import script from "./EditInput.vue?vue&type=script&lang=js"
export * from "./EditInput.vue?vue&type=script&lang=js"
import style0 from "./EditInput.vue?vue&type=style&index=0&id=67589a6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67589a6a",
  null
  
)

export default component.exports